const DATA_TEST_IDS = {
  updateAddressDialogUpdateAddressDialog:
    'profile-address__update-address-dialog',
} as const;

export default DATA_TEST_IDS;
